// extracted by mini-css-extract-plugin
module.exports = {"root":"GithubCorner_root__1Pzwv","svgRoot":"GithubCorner_svgRoot__32Pgg","octoArm":"GithubCorner_octoArm__23VoB","octocat-wave":"GithubCorner_octocat-wave__1O6mS"};